import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
/* eslint-disable flowtype/require-valid-file-annotation */
/* eslint no-param-reassign: 0 no-underscore-dangle: 0 */

import isoFetch from 'isomorphic-fetch';
import { computeBodyAndOptions, joinUrl, hasQuery, mergeOptions, serializeQuery, upgradeError, upgradeResponse } from './helpers';
var Fetcher = /*#__PURE__*/function () {
  /**
   * Note the Cookie options for server side:
   *
   * ```
   * new Fetcher('http://api-backend.dev/api/v5', {
   *  headers: {
   *    'Cookie': req.headers.cookie,
   *  },
   * });
   * ```
   *
   * @param String baseUrl  the base url for all calls.
   * @param Object options  isomorphic-fetch compatible options.
   */
  function Fetcher(baseUrl) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Fetcher);
    this._baseUrl = baseUrl;
    this._options = mergeOptions({
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      method: 'GET',
      timeout: 0
    }, options);
  }

  /**
   * Sets/Merges fetcher instance options
   * You can use it to merge several options objects
   * setOptions(source, source2, source3)
   * @param  {Object}  options       source options object
   * @return Fetcher
   */
  _createClass(Fetcher, [{
    key: "setOptions",
    value: function setOptions() {
      var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._options = mergeOptions(this._options, newOptions);
      return this;
    }
  }, {
    key: "endpoint",
    get: function get() {
      return this._baseUrl;
    }
  }, {
    key: "options",
    get: function get() {
      return _objectSpread({}, this._options);
    }

    /**
     * Direct map to isoFetch `fetch` method
     */
  }, {
    key: "fetch",
    value: function fetch(url) {
      var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var queryString = serializeQuery(fetchOptions.params || {});
      var queryUrl = joinUrl(this._baseUrl, url) + (queryString ? hasQuery(url) && '&' || '?' : '') + queryString;
      var queryOptions = mergeOptions(this._options, fetchOptions);

      // body for HEAD queries is empty
      var shouldUpgradeResponse = fetchOptions.method !== 'HEAD';
      return isoFetch(queryUrl, queryOptions).then(function (response) {
        var contentLength = response.headers.get('content-length');
        var isNoContentResponse = response.status === 204;
        if (shouldUpgradeResponse && !isNoContentResponse && (contentLength === undefined || contentLength === null || contentLength > 0)) return upgradeResponse(response);
        return response;
      }).then(function (response) {
        return _Promise.resolve(response);
      }, function (error) {
        var err = upgradeError(error);
        return _Promise.reject(err);
      });
    }

    /**
     * HEAD HTTP method short-hand
     * Uses the same API as `query`
     * @param  {String}  path         resource path
     * @param  {Object}  options      options object
     * @return {Query}   query        fetcher query object
     */
  }, {
    key: "head",
    value: function head(path) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(path, _objectSpread(_objectSpread({}, options), {}, {
        method: 'HEAD'
      }));
    }

    /**
     * GET HTTP method short-hand
     * Uses the same API as `query`
     * @param  {String}  path         resource path
     * @param  {Object}  options      options object
     * @return {Query}   query        fetcher query object
     */
  }, {
    key: "get",
    value: function get(path) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(path, _objectSpread(_objectSpread({}, options), {}, {
        method: 'GET'
      }));
    }

    /**
     * PUT HTTP method short-hand
     * Uses the same API as `query`
     * @param  {String}  path         resource path
     * @param  {Object|String}  body  request body
     * @param  {Object}  options      options object
     * @return {Query}   query        fetcher query object
     */
  }, {
    key: "put",
    value: function put(path, body) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.fetch(path, _objectSpread(_objectSpread({}, computeBodyAndOptions(body, options)), {}, {
        method: 'PUT'
      }));
    }

    /**
     * PATCH HTTP short-hand
     * Uses the same API as `query`
     * @param  {String}  path         resource path
     * @param  {Object|String}  body  request body
     * @param  {Object}  options      options object
     * @return {Query}   query        fetcher query object
     */
  }, {
    key: "patch",
    value: function patch(path, body) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.fetch(path, _objectSpread(_objectSpread({}, computeBodyAndOptions(body, options)), {}, {
        method: 'PATCH'
      }));
    }

    /**
     * DELETE HTTP method short-hand
     * Uses the same API as `query`
     * @param  {String}  path         resource path
     * @param  {Object|String}  body  request body
     * @param  {Object}  options      options object
     * @return {Query}   query        fetcher query object
     */
  }, {
    key: "delete",
    value: function _delete(path, body) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.fetch(path, _objectSpread(_objectSpread({}, computeBodyAndOptions(body, options)), {}, {
        method: 'DELETE'
      }));
    }

    /**
     * POST HTTP method short-hand
     * Uses the same API as `query`
     * @param  {String}  path         resource path
     * @param  {Object|String}  body  request body
     * @param  {Object}  options      options object
     * @return {Query}   query        fetcher query object
     */
  }, {
    key: "post",
    value: function post(path, body) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.fetch(path, _objectSpread(_objectSpread({}, computeBodyAndOptions(body, options)), {}, {
        method: 'POST'
      }));
    }
  }]);
  return Fetcher;
}();
export { Fetcher as default };